import React from 'react';
import { useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';
import {
  setSelected,
  deletePlan as deletePlanAction,
} from '../../../PlanSelectionNewWhatIfs/PlanSelectionNewWhatIfsActions';
import { Modal } from '../../../CommonComponents/OPL/Modal/Modal';
import { ModalHeader } from '../../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalFooter } from '../../../CommonComponents/OPL/Modal/ModalFooter';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { Button } from '../../../CommonComponents/OPL/Button/Button';
import { toast } from '../../../CommonComponents/OPL/Toast/Toast';
import { useEditPlanMutation } from '../../api/useEditPlanMutation';
import { useProposedPlansQuery } from '../../api/useProposedPlansQuery';
import { useSelectedPlan } from '../../hooks/useSelectedPlan';
import { useRouteParams } from '../../hooks/useRouteParams';
import { queryKeys } from '../../api/queryKeys';

interface Props {
  closeModal: () => void;
}

export const DeletePlanModal: React.FC<Props> = ({ closeModal }) => {
  const { data } = useProposedPlansQuery();

  const selectedPlan = useSelectedPlan();

  const { clientId } = useRouteParams();

  const dispatch = useDispatch();

  const { mutateAsync: deletePlan, isLoading: isDeletingPlan } = useEditPlanMutation();

  const queryClient = useQueryClient();

  if (!data || !selectedPlan) {
    return null;
  }

  const handleDeletePlan = async () => {
    try {
      await deletePlan({
        clientId,
        PlansToDelete: [selectedPlan],
      });

      //  TODO (LEGACY): Remove after the migration is complete
      dispatch(deletePlanAction(selectedPlan.planId, clientId));
      dispatch(setSelected(data[0].planId, clientId));

      queryClient.invalidateQueries(queryKeys.proposedPlans(clientId));

      toast.success('Plan is deleted successfully.');
    } catch (err) {
      toast.error('An error occurred. Please try again later.');
    }

    closeModal();
  };

  return (
    <Modal
      isOpen
      onRequestClose={closeModal}
      aria={{ labelledby: 'plan-selection--delete-plan-modal-heading' }}
    >
      <ModalHeader variant="warning" id="plan-selection--delete-plan-modal-heading">
        Are you sure you want to delete this plan?
      </ModalHeader>

      <ModalFooter>
        <Box display="flex" justifyContent="flex-end">
          <Button disabled={isDeletingPlan} variant="subtleInactive" onClick={closeModal}>
            Cancel
          </Button>

          <Button
            isLoading={isDeletingPlan}
            ml="12"
            variant="error"
            onClick={() => handleDeletePlan()}
          >
            Delete Plan
          </Button>
        </Box>
      </ModalFooter>
    </Modal>
  );
};
